import { render, staticRenderFns } from "./MainMenuBar.vue?vue&type=template&id=0dab05c9&scoped=true&"
import script from "./MainMenuBar.vue?vue&type=script&lang=js&"
export * from "./MainMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuBar.vue?vue&type=style&index=0&id=0dab05c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab05c9",
  null
  
)

export default component.exports